import HarmonyCoupon from './harmony-coupon';
import SuperRights from './super-rights';
import HarmonyTab from './harmony-tab';

export default {
  HarmonyCoupon,
  SuperRights,
  HarmonyTab,
};
